import _typeof from "@babel/runtime/helpers/typeof";
export function classNames() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!className || _typeof(className) !== 'object') {
    return '';
  }
  var keys = Object.keys(className);
  return keys.reduce(function (accum, key) {
    if (key && className[key]) {
      return !accum ? key : "".concat(accum, " ").concat(key);
    }
    return accum;
  }, '');
}